// src/apis/configs/axiosConfigs.js

import axios from "axios"
import env from '../../auth/environment'

export const api = axios.create({baseURL: env.apiBaseUrl})

// defining a custom error handler for all APIs
const errorHandler = (error: { response: { status?: number } }) => {
  if (error.response) {
    const { status } = error.response;
    if (status) {
      if (status >= 400 && status < 500) {
        console.error('Client error:', error);
      } else if (status >= 500 && status < 600) {
        console.error("Server error", error);
      } else {
        console.error("Other error", error);
      }
    }
  } else {
    console.error("Network error", error);
  }

  return Promise.reject(error)
};

// registering the custom error handler to the
// "api" axios instance
api.interceptors.response.use(undefined, (error) => {
  return errorHandler(error)
})
